<template>
	<div class="shadow-card bg-default rounded-xl flex px-8 flex-col gap-4 w-[300px]">
		<div class="mt-6 flex flex-col items-center justify-center min-h-16">
			<NuxtLink
				:id="HELP_CENTER_CARD_TITLE_LINK"
				:to="`${HELP_CENTER_BASE_URL_EN}/collections/${$rt(card.catSlug)}`"
				class="text-xl font-semibold text-center text-highlighted hover:text-primary"
				external
				target="_blank"
				@click="trackEvent($event, trackingLocation, {
					category: card.title,
					category_slug: card.catSlug
				})"
				@mouseenter="trackEvent($event, trackingLocation, {
					category: card.title,
					category_slug: card.catSlug
				})"
				@focus="trackEvent($event, trackingLocation, {
					category: card.title,
					category_slug: card.catSlug
				})"
			>
				{{ $rt(card.title) }}
			</NuxtLink>
		</div>
		<div class="flex flex-col justify-end items-stretch w-full">
			<div
				v-for="item in card.items"
				:key="item.text"
				class="border-b-1 border-dimmed min-h-10 pt-6 first-of-type:pt-0 w-full flex flex-col items-start justify-items-end"
			>
				<NuxtLink
					:id="HELP_CENTER_CARD_ITEM_LINK"
					:to="`${HELP_CENTER_BASE_URL_EN}/articles/${item.slug}`"
					class="text-highlighted text-sm mt-auto py-2 font-semibold hover:text-primary"
					external
					target="_blank"
					@click="trackEvent($event, trackingLocation, {
						article: item.text,
						article_slug: item.slug,
						category: card.title
					})"
					@mouseenter="trackEvent($event, trackingLocation, {
						article: item.text,
						article_slug: item.slug,
						category: card.title
					})"
					@focus="trackEvent($event, trackingLocation, {
						article: item.text,
						article_slug: item.slug,
						category: card.title
					})"
				>
					{{ item.text }}
				</NuxtLink>
			</div>
		</div>
		<div class="mt-auto mb-6 h-10 flex flex-col items-start justify-center">
			<NuxtLink
				:id="HELP_CENTER_CARD_VIEW_ALL_LINK"
				:to="`${HELP_CENTER_BASE_URL_EN}/collections/${$rt(card.catSlug)}`"
				target="_blank"
				class="text-sm text-primary font-semibold"
				external
				@click="trackEvent($event, trackingLocation, {
					category: card.title,
					category_slug: card.catSlug
				})"
				@mouseenter="trackEvent($event, trackingLocation, {
					category: card.title,
					category_slug: card.catSlug
				})"
			>
				{{ $rt(card.questions) }}
			</NuxtLink>
		</div>
	</div>
</template>

<script setup lang="ts">
import { useGA4Tracking } from '@/composables/useGA4Tracking'
import type { HelpCenterCard } from '@/constants/components/help-center'
import {
	HELP_CENTER_CARD_ITEM_LINK,
	HELP_CENTER_CARD_TITLE_LINK,
	HELP_CENTER_CARD_VIEW_ALL_LINK
} from '@/constants/ga4/tracking-ids'
import { HELP_CENTER_BASE_URL_EN } from '@/constants/index.js'

defineProps({
	card: {
		type: Object as () => HelpCenterCard,
		required: true
	},
	trackingLocation: {
		type: String,
		default: 'help_center'
	}
})

const { trackEvent } = useGA4Tracking()
</script>
